import React, { createContext, useEffect, useState } from "react";
import App from "./App";
import toast, { Toaster } from "react-hot-toast";
import copy from "copy-to-clipboard";
import { ethers } from "ethers";
import { useAccount, useChainId, useChains, useSwitchChain } from "wagmi";
import useEthersProvider from "./Component/hooks/useEthersProvider";
import useEthersSigner from "./Component/hooks/useEthersSigner";
import contractdata from './contract.json'
import { error } from "ajv/dist/vocabularies/applicator/dependencies";

export const ProjectContext = createContext();

function Projectcontext() {
  const provider = useEthersProvider();
  const signer = useEthersSigner();
  const { isConnected,
    address
  } = useAccount();
//   const address = "0x544aD84403DC3dC31dEa7F0d3dc55aB9219BC88f";


  const [selectToken, setselectToken] = useState(false);
  const [Ubalance, setUBalance] = useState(0);
  const [Dbalance, setDBalance] = useState(0);
  const [settings, setsettings] = useState([]);
  // start
  const [esigner, setesigner] = useState(null);
  const [dnetRate, setdnetRate] = useState(0);
  const [dbbalance, setdbbalance] = useState(0);
  const [Earnig, setEarnig] = useState(0);
  const [Team, setTeam] = useState(0);
  const [dbReward, setdbReward] = useState(0);
  const [DailReawardCap, setDailReawardCap] = useState(0);
  const [x2balance, setx2balance] = useState(0);
  const [dbuser, setdbuser] = useState(null);
  const [dbuserx1, setdbuserx1] = useState(0);
  const [usertnx, setusertnx] = useState(null);
  const [usertnxDate, setusertnxDate] = useState(null);
  const [account, setaccount] = useState(address);
  const [dnetcontract, setdnetcontract] = useState(null);
  const [Maincontract, setMaincontract] = useState(null);
  const [Usdtcontract, setUsdtcontract] = useState(null);
  const [DailyReward, setDailyReward] = useState(null);
  const [CapDailyReward, setCapDailyReward] = useState(null);
  const [DailyRoi, setDailyRoi] = useState(null);
  const [Rank, setRank] = useState("");
  const [PDailyReward, setPDailyReward] = useState(null);
  const [PLevelReward, setPLevelReward] = useState(null);
  const [AllReward, setAllReward] = useState([]);
  const [LMinW, setLMinW] = useState(0);
  const [RMinW, setRMinW] = useState(0);
  const [user72Date, setuser72Date] = useState(null);
  const [PerformanceBusiness, setPerformanceBusiness] = useState(0);
  const [AllRewardNew, setAllRewardNew] = useState([]);
  const [TDailyRew, setTDailyRew] = useState(0);
  const [Maincontract1, setMaincontract1] = useState(null);
  const [Elite, setElite] = useState(0);
  const [Time, setTime] = useState(0);

  // end
  const [reloadData, setreloadData] = useState(false);

  const [Refaddress, setRefAddress] = useState(dbuser?.ref_address || localStorage.getItem('referralAddress') || ''); // Default to an empty string if not available

  useEffect(() => {
    // Only update Refaddress if it's empty and dbuser has ref_address
    if (!Refaddress && dbuser?.ref_address) {
      setRefAddress(dbuser.ref_address);
    }
  }, [dbuser]); // Only watch dbuser for changes

  const formatAddress = (address) => {
    if (address) {
      return address.substr(0, 6) + "..." + address.substr(-6, 6);
    }
  };
  function reload() {
    setreloadData(!reloadData)
  }

  const toastError = (data) => {
    toast.error(data);
  };
  const toastSuccess = (data) => {
    toast.success(data);
  };
  const toastInfo = (data) => {
    toast(data, {
      // Custom Icon
      icon: "❕",
      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  };

  const copyaddress = (address) => {
    copy(address);
    toastSuccess("Copy");
  };

  const getSetting = async () => {
    setsettings(contractdata);
  };

  function formatDateTime(timestamp) {
    // If timestamp is '0' or invalid, return a fallback value
    if (!timestamp) {
      return '-';
    }

    // Create a Date object from the ISO 8601 string
    const date = new Date(timestamp);

    // Check if it's a valid date
    if (isNaN(date)) {
      return 'Invalid Date';
    }

    // Get the date components
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Get the time components
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Construct the formatted date-time string
    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  }

  function getFormattedDate(timestamp) {
    // Convert timestamp (assuming it is in seconds, hence multiplying by 1000)
    const date = new Date(Number(timestamp) * 1000);

    // Extract components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Format in YYYY-MM-DDTHH:MM:SS format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  const getSigner = async () => {
    if (!isConnected) return;
    setesigner(signer)
    let contract;
    let maincontractwrite;
    let dnet_contract;
    let maincontractwrite1;
    try {
      contract = new ethers.Contract(settings.token, settings.token_abi, signer);
      dnet_contract = new ethers.Contract(settings.dnet, settings.dnet_abi, signer);
      maincontractwrite = new ethers.Contract(settings.contract, settings.contract_abi, signer);

      maincontractwrite1 = new ethers.Contract(settings.contract1, settings.contract_abi, signer);
    } catch (error) {
      console.error("Error initializing contracts:", error);
      return;
    }
    setMaincontract(maincontractwrite);
    setMaincontract1(maincontractwrite1);
    setUsdtcontract(contract);
    setdnetcontract(dnet_contract);
  }

  useEffect(() => {
    if (isConnected && account && provider && signer) {
      getSigner();
    }
  }, [isConnected, account, provider, signer]);

  const getsmcs = async () => {

    if (!isConnected || !settings.token || esigner === null) return;

    let contract;
    let maincontractwrite;
    let maincontractwrite1;
    let dnet_contract;

    try {
      contract = new ethers.Contract(settings.token, settings.token_abi, esigner);
      dnet_contract = new ethers.Contract(settings.dnet, settings.dnet_abi, esigner);
      maincontractwrite = new ethers.Contract(settings.contract, settings.contract_abi, esigner);
    } catch (error) {
      console.error("Error initializing contracts:", error);
      return;
    }
    // dnet Token Rate
    // const dnetRate = await maincontractwrite.tokenrate();
    // // console.log("Demo", Number(ethers.utils.formatUnits(dnetRate, 6)).toFixed(8))
    // setdnetRate(Number(ethers.utils.formatUnits(dnetRate, 6)).toFixed(8));

    // // Fetch the balance for USDT
    // const ubalance = await contract.balanceOf(address);
    // const formattedUbalance = Number(ethers.utils.formatUnits(ubalance, 6)).toFixed(2);
    // setUBalance(formattedUbalance);
    // // console.log(`USDT Balance: ${formattedUbalance}`);

    // // Fetch the balance for dnet
    // const dbalance = await dnet_contract.balanceOf(address);
    // const formattedDbalance = Number(ethers.utils.formatUnits(dbalance, 6)).toFixed(2);
    // setDBalance(formattedDbalance);
    // // console.log(`dnet Balance: ${formattedDbalance}`);

    setMaincontract(maincontractwrite);
    setUsdtcontract(contract);
    setdnetcontract(dnet_contract);


    try {

      const getUser = await maincontractwrite.users(account);
      // console.log("Raw getUser response:", getUser);

      if (!getUser || getUser.length === 0) {
        console.error("No user data found for address:", account);
        return null;
      }


      const userData = {
        ref_address: getUser[0],
        address: getUser[1],
        stake: ethers.utils.formatUnits(getUser[2], 6),
        times: ethers.utils.formatUnits(getUser[3], 6),
        directs: Number(getUser[4].toString()),
        date: ethers.utils.formatUnits(getUser[5], 6),
        elite: getUser[6],
        isLegacy: getUser[10],
        isperformance: getUser[11],
        lastpackage: getUser[7],
        // referrals: getUser[8],
        status: Number(getUser[8]),
      };
      setdbuser(userData);

      // console.log("Formatted user data:", userData);
      // console.log("CHECK C", userData.address.toLowerCase() === account.toLowerCase(), userData.address, account);
      let userStatisticsData = {}; // Ensure it is dneted here before usage
      if (userData.address.toLowerCase() === account.toLowerCase()) {

        // 72 Hours Timer
        const userhours72 = await maincontractwrite.userhours72(account);
        setuser72Date(userhours72.toLocaleString());
        console.log("userhours72[0].toLocaleString()", userhours72.toString());

        // Performance Business
        const PerformanceBusiness = await maincontractwrite.userl1teambusiness(account);
        var PBusiness = Number(ethers.utils.formatUnits(PerformanceBusiness.toString(), 6));
        setPerformanceBusiness(PBusiness);
        console.log("PerformanceBusiness", Number(ethers.utils.formatUnits(PerformanceBusiness.toString(), 6)));


        const getUserElite = await maincontractwrite.userelite(account);
        // console.log("getUserElite", getUserElite,  Number(getUserElite.toString()));

        setElite(Number(getUserElite.toString()));

        // User statistics
        const getUserStatistics = await maincontractwrite.userstatistics(account);

        userStatisticsData = {
          lwithdrawal: ethers.utils.formatUnits(getUserStatistics[0], 6),
          rwithdrawal: ethers.utils.formatUnits(getUserStatistics[1], 6),
          levelreward: ethers.utils.formatUnits(getUserStatistics[2], 6),
          dailyreward: ethers.utils.formatUnits(getUserStatistics[3], 6),
          legacyreward: ethers.utils.formatUnits(getUserStatistics[4], 6),
          performancereward: ethers.utils.formatUnits(getUserStatistics[5], 6),

        };
        setAllReward(userStatisticsData)
        var totaDaiilyRew = Number(AllReward?.rwithdrawal) + Number(AllRewardNew?.rwithdrawal)
        setTDailyRew(totaDaiilyRew);
        console.log("totaDaiilyRew", totaDaiilyRew, AllReward, AllRewardNew?.rwithdrawal);



        // User Team
        const getUserTeam = await maincontractwrite.getuserteam(account);
        setTeam(getUserTeam.toString());
        console.log("getUserTeam.toString()", getUserTeam.toString());

        // console.log("getUserTnx", userData?.lastpackage.toString());

        // Get User Tnx
        const getUserTnx = await maincontractwrite.transactions(userData?.lastpackage.toString());
        console.log("getUserTnx", getUserTnx[9].toLocaleString());

        setusertnx(ethers.utils.formatUnits(getUserTnx[2], 6));
        setusertnxDate(getUserTnx[10].toLocaleString());



        const x15cap = ethers.utils.formatUnits(getUserTnx[2], 6) * 1.5;
        const currentTimestamp = Math.floor(Date.now() / 1000);


        // // User Capping
        const timestamp = Math.floor(Date.now() / 1000);
        setTime(timestamp);
        console.log("D", timestamp);
        const getUserCap = await maincontractwrite.capping(account, timestamp);
        console.log("getUserCap", getUserCap.toLocaleString());

        const calsetPDailyReward = Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(userStatisticsData.dailyreward) - Number(userStatisticsData.rwithdrawal);
        const calsetPLevelReward = Number(userStatisticsData.levelreward) + Number(userStatisticsData.legacyreward) + Number(userStatisticsData.performancereward) - Number(userStatisticsData.lwithdrawal);
        console.log("PLevelReward", Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(userStatisticsData.dailyreward) - Number(userStatisticsData.rwithdrawal));

        setPLevelReward(calsetPLevelReward);
        setPDailyReward(calsetPDailyReward);


        // setusertnxDate(getUserCap[3].toString());

        // console.log("getUserCap", getUserCap[3].toLocaleString(), "--------", ethers.utils.formatUnits(getUserCap[0], 6));
        setCapDailyReward(Number(ethers.utils.formatUnits(getUserCap[0], 6)))

        //Daily Reward
        const getDailyReward = Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(userStatisticsData?.dailyreward);
        setDailyReward(getDailyReward);
        console.log("getDailyReward", getDailyReward);



        // const getDailyRoi = await maincontractwrite.daily_roi();
        // setDailyRoi(Number(ethers.utils.formatUnits(getDailyRoi, 6)));

        // Main balance
        // const mainbalance = Number(
        //   Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(userData?.levelreward) + Number(userData?.dailyreward) - Number(userData?.withdrawal)
        // ).toFixed(2);
        // setdbbalance(mainbalance);

        // Total Earning
        // Number(ethers.utils.formatUnits(getUserCap[0], 6)) + 
        const earnig = Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(userStatisticsData?.levelreward) + Number(userStatisticsData?.dailyreward) + Number(userStatisticsData?.legacyreward) + Number(userStatisticsData?.performancereward);
        setEarnig(earnig);

        console.log("Earning", Number(ethers.utils.formatUnits(getUserCap[0], 6)));

        // Total Reward
        const totalReward = Number(ethers.utils.formatUnits(getUserCap[0], 6)) + Number(ethers.utils.formatUnits(getUserTnx[6], 6)) + Number(ethers.utils.formatUnits(getUserTnx[4], 6)) + Number(ethers.utils.formatUnits(getUserTnx[7], 6));
        // setDailReawardCap(ethers.utils.formatUnits(getUserCap[0], 6));
        console.log("totalReward", x15cap);

        setdbReward(totalReward);
        setdbuserx1(x15cap);

        // const getRank = await maincontractwrite.userabove100(account);

        // // Convert the value to a number and check the rank in the right order
        // const rankValue = getRank.toString();
        // console.log("rankValue", rankValue, getRank);
        // // console.log("1.5x income", x15cap, dbbalance);
      }
      // Assuming userStatisticsData is an object
      return userData; // Same logic

    } catch (error) {
      console.error("Error during contract calls or calculations:", error);
    }
  };


  const CheckReffaral = async () => {

    try {

      // Check if the referral address is the default address
      if (Refaddress === settings.defult_address) {
        console.log("Referral address matches default address.");
        localStorage.setItem('referralAddress', Refaddress);
        return { success: true, code: 200 };
      }

      // Fetch the user data associated with the referral address
      const getRUser = await Maincontract.users(Refaddress);
      if (!getRUser || getRUser.length === 0) {
        console.error("No user data found for address:", Refaddress);
        toastError("No user data found for referral address!");
        return { error: "No user data found", code: 404 };
      }

      const userRData = {
        ref_address: getRUser[0],
        address: getRUser[1],
      };
      console.log("Refaddress-------->", Refaddress, userRData);

      // Fetch capping information for the user
      const getUserCap = await Maincontract.capping(userRData.address, Math.floor(Date.now() / 1000));
      const capTime = getUserCap[3].toLocaleString();  // Example: Get the capping time
      console.log("Capping info", capTime);

      // Compare the capping time with the current time
      const checkTimee = getFormattedDate(capTime);
      const timestamp = Math.floor(Date.now() / 1000); // Get current timestamp
      const checkTimee2 = getFormattedDate(timestamp);

      console.log("Comparing capping times", checkTimee, checkTimee2, checkTimee < checkTimee2);

      if (checkTimee < checkTimee2) {
        toastError("Backers Not Active!");
        return { error: "Backers not active", code: 400 };
      }
      localStorage.setItem('referralAddress', Refaddress);

      // If all checks pass, return success
      return { success: true, code: 200 };
    } catch (error) {
      console.error("Error during contract calls or CheckReffaral:", error);
      toastError("Invalid Backers Link!");
      return { error: "Invalid referral", code: 400 };
    }
  };

  useEffect(() => {
    // Optionally, you can also call getSetting() here if needed
    getSetting();
  }, [reloadData]);

  const fetchMinWithdrawal = async () => {
    try {
      const lmin = await Maincontract.lminwithdrawal();
      const rmin = await Maincontract.rminwithdrawal();

      setLMinW(Number(ethers.utils.formatUnits(lmin.toString(), 6)));
      setRMinW(Number(ethers.utils.formatUnits(rmin.toString(), 6)));
    } catch (error) {
      console.error('Error fetching min withdrawal:', error);
    }
  };

  // console.log("lmin", LMinW, "rmin", RMinW);



  // Set up useEffect to trigger on necessary dependencies
  useEffect(() => {
    getsmcs();
  }, [
    isConnected,
    account,
    settings,
    esigner,
    reloadData,
  ]);


  useEffect(() => {
    setaccount(address);
    if (address) {
      fetchMinWithdrawal();
    }
  }, [address]);



  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          // Default options for all toasts
          className: "",
          duration: 3000,
          style: {
            background: "#fff", // Background color for all toasts
            color: "#000", // Text color for all toasts
            fontWeight: "bold", // Example additional style
            borderRadius: "8px", // Rounded corners for the toast
            padding: "16px", // Toast padding
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green", // Green background for success toasts
              secondary: "white", // White text color for success toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(0, 128, 0, 0.2)", // Add shadow for success toasts
            },
          },
          error: {
            duration: 3000,
            theme: {
              primary: "red", // Red background for error toasts
              secondary: "white", // White text color for error toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(255, 0, 0, 0.2)", // Add shadow for error toasts
            },
          },
          loading: {
            duration: 3000,
            theme: {
              primary: "blue", // Blue background for loading toasts
              secondary: "white", // White text color for loading toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(0, 0, 255, 0.2)", // Add shadow for loading toasts
            },
          },
        }}
      />

      <ProjectContext.Provider
        value={{
          settings: settings,
          library: ethers,
          dbuser,
          esigner,
          account: account ? account?.toLowerCase() : account,
          formatAddress,
          toastError,
          toastSuccess,
          dbbalance,
          toastInfo,
          getsmcs,
          ethers,
          copyaddress,
          Maincontract, dnetcontract,
          formatDateTime, setaccount,
          reload, reloadData, useSwitchChain,
          setdbuser,
          // For New Project
          x2balance, setx2balance, usertnx, setusertnx, Refaddress, setRefAddress, dbuserx1, dbReward, DailReawardCap, usertnxDate, Earnig, Team, Ubalance, Dbalance, dnetRate, Usdtcontract, DailyReward, DailyRoi, CapDailyReward, getFormattedDate, CheckReffaral, AllReward, PDailyReward, PLevelReward, getSetting, LMinW, RMinW, user72Date, Rank, Maincontract1, AllRewardNew, TDailyRew, Elite, PerformanceBusiness, Time,
        }}
      >
        <App />
      </ProjectContext.Provider>
    </>
  );
}

export default Projectcontext;